import { LicenseStatus, OaiboxGradient } from "@allbesmart/web-app-common";

interface LicenseStatusConfig {
  label: string,
  color: OaiboxGradient,
}

export const LICENSE_STATUS_CONFIG: { [key in LicenseStatus]: LicenseStatusConfig } = {
  [LicenseStatus.ACTIVE]: { label: 'Active', color: 'success' },
  [LicenseStatus.INACTIVE]: { label: 'Inactive', color: 'danger' },
  [LicenseStatus.PAUSED]: { label: 'Paused', color: 'warning' },
  [LicenseStatus.PERPETUAL]: { label: 'Perpetual', color: 'success' },
}
